import { FormGroup } from '@angular/forms';

/**
 * Cofirms password validator
 * @param controlName 
 * @param matchingControlName 
 * @returns (formGroup: FormGroup) => void
 */
export function CofirmPasswordValidator(
    controlName: string,
    matchingControlName: string
): (formGroup: FormGroup) => void {
    return (formGroup: FormGroup) => {
        const control = formGroup.controls[controlName];
        const matchingControl = formGroup.controls[matchingControlName];
        
        if (matchingControl.errors && !matchingControl.errors.confirmPasswordValidator) {
            return;
        }
        
        if (control.value !== matchingControl.value) {
            matchingControl.setErrors({ confirmPasswordValidator: true });
        } else {
            matchingControl.setErrors(null);
        }
    };
}
